import { GlDisclosureDropdown, GlDisclosureDropdownGroup, GlDisclosureDropdownItem, GlTooltipDirective } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { s__, __ } from '~/locale';
import { isTemplate } from '../utils';
import CloneWikiModal from './clone_wiki_modal.vue?vue3';
import DeleteWikiModal from './delete_wiki_modal.vue?vue3';
export default {
    name: 'WikiMoreDropdown',
    components: {
        GlDisclosureDropdown,
        GlDisclosureDropdownGroup,
        GlDisclosureDropdownItem,
        CloneWikiModal,
        DeleteWikiModal
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    inject: {
        canCreateNewPage: {
            default: false
        },
        newUrl: {
            default: null
        },
        historyUrl: {
            default: null
        },
        templatesUrl: {
            default: null
        },
        pagePersisted: {
            default: null
        }
    },
    props: {
        deleteModalId: {
            type: String,
            required: false,
            default: 'delete-wiki-modal'
        },
        cloneModalId: {
            type: String,
            required: false,
            default: 'clone-wiki-modal'
        },
        dropdownTestid: {
            type: String,
            required: false,
            default: 'wiki-more-dropdown'
        }
    },
    i18n: {
        wikiActions: s__('Wiki|Wiki actions')
    },
    data () {
        return {
            isDropdownVisible: false
        };
    },
    computed: {
        isTemplate,
        templateLinkClass () {
            return '';
        },
        newItem () {
            return {
                text: this.isTemplate ? s__('Wiki|New template') : s__('Wiki|New page'),
                href: this.newUrl,
                extraAttrs: {
                    'data-testid': 'page-new-button'
                }
            };
        },
        historyItem () {
            return {
                text: this.isTemplate ? s__('Wiki|Template history') : s__('Wiki|Page history'),
                href: this.historyUrl,
                extraAttrs: {
                    'data-testid': 'page-history-button'
                }
            };
        },
        printItem () {
            return {
                text: __('Print as PDF'),
                action: this.printPage,
                extraAttrs: {
                    'data-testid': 'page-print-button'
                }
            };
        },
        templateItem () {
            return {
                text: __('Templates'),
                href: this.templatesUrl,
                extraAttrs: {
                    class: this.templateLinkClass,
                    'data-testid': 'page-templates-button'
                }
            };
        },
        showDropdownTooltip () {
            return !this.isDropdownVisible ? this.$options.i18n.wikiActions : '';
        },
        showPrintItem () {
            return !this.isTemplate && this.pagePersisted;
        }
    },
    methods: {
        printPage () {
            document.querySelectorAll('img').forEach((img)=>img.setAttribute('loading', 'eager'));
            document.querySelectorAll('details').forEach((detail)=>detail.setAttribute('open', ''));
            window.print();
        },
        showDropdown () {
            this.isDropdownVisible = true;
        },
        hideDropdown () {
            this.isDropdownVisible = false;
        }
    }
};
